import $ from 'jquery';

export default class SlickSlider {
    #$carousel;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        this.#utils.log("Slider Initialized");
        this.#$carousel = $(".slick-block-slider");

        this.#utils.log(this.#$carousel);

    }

    setup() {
        this.#utils.log("Slick Initialized");
        this.#$carousel.slick();
    }

    show() {
        this.#utils.log("Slider loaded");

    }
}